import { render, staticRenderFns } from "./sky-ueditor.vue?vue&type=template&id=45c98a33"
import script from "./sky-ueditor.vue?vue&type=script&lang=js"
export * from "./sky-ueditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports